import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import Welcome from './Welcome';
import End from './End';
import Verify from './Verify';
import AgreementNew from './AgreementNew';
import Inbox from './Inbox';
import Archives from './Archives';
import Settings from './Settings';
import DocumentViewer from './inbox/DocumentViewer';
import { agreement_check } from './../../sagas/sessions';

//import FeedbackButton from '../shared/FeedbackButton';

class Main extends Component {
    render = () => {
        const { sessions } = this.props;

        // Checked if logged in
        if (!sessions.data) {
            return (
                <Redirect
                    to={{
                        pathname: '/login/redirect' + this.props.location.pathname
                    }}
                />
            );
        } else if (agreement_check && sessions.data.missingFields) {
            const allowed_routes = ['/agreement', '/end', '/accept', '/end/accept'];
            // If missing fields redirect all routes to agreement
            if (allowed_routes.indexOf(this.props.location.pathname) === -1) {
                return (
                    <Redirect
                        to={{
                            pathname: '/accept'
                        }}
                    />
                );
            }
        }

        return (
            <section className="main-layout">
                <Switch>
                    <Route path="/welcome" component={Welcome} />
                    <Route path="/verify" component={Verify} />
                    <Route path="/accept" component={AgreementNew} />
                    <Route path="/end/:referer" component={End} />
                    <Route path="/inbox" component={Inbox} />
                    <Route path="/archives" component={Archives} />
                    <Route path="/settings" component={Settings} />
                    <Route path="/document/:id" component={DocumentViewer} />
                    <Redirect to="/inbox" />
                </Switch>
            </section>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        sessions: state.sessions
    };
};

export default connect(mapStateToProps)(Main);



// WEBPACK FOOTER //
// ./src/components/views/Main.js